 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTMLCOVER from '@/components/xhtml/cover'
 import XHTMLTITLE from '@/components/xhtml/title'
 import XHTMLCOPYRIGHT from '@/components/xhtml/copyright'
 import XHTMLCONTENTS from '@/components/xhtml/contents'
 import XHTMLFOREWORD from '@/components/xhtml/foreword'
 import XHTMLAUTHOR_NOTE from '@/components/xhtml/author_note'
 import XHTMLCH01 from '@/components/xhtml/ch01'
 import XHTMLCH02 from '@/components/xhtml/ch02'
 import XHTMLCH03 from '@/components/xhtml/ch03'
 import XHTMLCH04 from '@/components/xhtml/ch04'
 import XHTMLCH05 from '@/components/xhtml/ch05'
 import XHTMLCH06 from '@/components/xhtml/ch06'
 import XHTMLCH07 from '@/components/xhtml/ch07'
 import XHTMLCH08 from '@/components/xhtml/ch08'
 import XHTMLCH09 from '@/components/xhtml/ch09'
 import XHTMLCH10 from '@/components/xhtml/ch10'
 import XHTMLCH11 from '@/components/xhtml/ch11'
 import XHTMLCH12 from '@/components/xhtml/ch12'
 import XHTMLCH13 from '@/components/xhtml/ch13'
 import XHTMLCH14 from '@/components/xhtml/ch14'
 import XHTMLCH15 from '@/components/xhtml/ch15'
 import XHTMLTHE_END from '@/components/xhtml/the_end'
 import XHTMLAPPENDIX1 from '@/components/xhtml/appendix1'
 import XHTMLAPPENDIX2 from '@/components/xhtml/appendix2'
 import XHTMLMAP from '@/components/xhtml/map'
 import XHTMLCHRONOLOGY from '@/components/xhtml/chronology'
 import XHTMLGLOSSARY from '@/components/xhtml/glossary'
 import XHTMLBIBLIOGRAPHY from '@/components/xhtml/bibliography'
 import XHTMLINDEX from '@/components/xhtml/index'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/cover",
 			"name" : "xhtml/cover",
 			"component" : XHTMLCOVER
 		},
 		{
 			"path" : "/xhtml/title",
 			"name" : "xhtml/title",
 			"component" : XHTMLTITLE
 		},
 		{
 			"path" : "/xhtml/copyright",
 			"name" : "xhtml/copyright",
 			"component" : XHTMLCOPYRIGHT
 		},
 		{
 			"path" : "/xhtml/contents",
 			"name" : "xhtml/contents",
 			"component" : XHTMLCONTENTS
 		},
 		{
 			"path" : "/xhtml/foreword",
 			"name" : "xhtml/foreword",
 			"component" : XHTMLFOREWORD
 		},
 		{
 			"path" : "/xhtml/author_note",
 			"name" : "xhtml/author_note",
 			"component" : XHTMLAUTHOR_NOTE
 		},
 		{
 			"path" : "/xhtml/ch01",
 			"name" : "xhtml/ch01",
 			"component" : XHTMLCH01
 		},
 		{
 			"path" : "/xhtml/ch02",
 			"name" : "xhtml/ch02",
 			"component" : XHTMLCH02
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js